export enum CaptchaAction {
  LOGIN = 'login',
  REGISTER = 'register',
  GENERATE_TOKEN_RESET_PASSWORD = 'generate_token_reset_password',
  RESET_PASSWORD = 'reset_password',
}
